export default __webpack_public_path__ + "static/media/tiger_standup.0185a2c9.png";